<template>
<div class="card mb-4">
<div class="card-header pb-0">
<h6>Projects table</h6>
</div>
<div class="card-body px-0 pt-0 pb-2">
<div class="table-responsive col-lg-12 p-0">
 <table class="table align-items-center justify-content-center mb-0">
   <div v-for="(project, id) in this.$store.state.projects" v-bind:key="project.id">
        <h2 class="h3"><strong>{{project.name }}</strong></h2>
        <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Block type</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Number made</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Total Required</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2">Completion</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2">Details</th>            
          </tr>
        </thead>
        <tbody>
          <tr   
            v-for="block in this.$store.state.blocks.filter(block => block.project === project.id)" v-bind:key="block.id">
              <td>
                <div class="d-flex flex-column px-2 py-4">
                  <div class="my-auto">
                    <h6 class="mb-0 text-sm">{{ block.name }}</h6>
                  </div>
                </div>
               </td>
              <td>
                <div class="d-flex px-4">
                  <p class="text-sm font-weight-bold mb-0">{{ block.number }}</p>
                </div>
              </td>
              <td>
                <div class="d-flex px-4 py-4">
                  <span class="text-xs font-weight-bold">{{ block.number_required }}</span>
                </div>
              </td>
              <td class="align-middle text-center">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="me-2 text-xs font-weight-bold">{{ Math.ceil(block.number / block.number_required * 100) }}%</span>
                  <div>
                  <div class="progress" style="height: 15px;">
                  <div class="progress-bar bg-gradient-success" role="progressbar" v-bind:aria-valuenow="(block.number / block.number_required) * 100" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: block.number / block.number_required * 100 + '%' }"></div>
                  </div>
                  </div>
                </div>
              </td>
              <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" :id="`heading${project.id}`">
                    <button
                      class="btn btn-success"
                      :class="{ collapsed: id > 0 }"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="`#collapse${project.id}`"
                      :aria-expanded="id === 0"
                      :aria-controls="`collapse${project.id}`"
                    >
                      View details
                    </button>
                  </h2>
                  <div
                    :id="`collapse${project.id}`"
                    class="accordion-collapse collapse"
                    :class="{ show: id === 0 }"
                    :aria-labelledby="`heading${project.id}`"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <span class="is-size-5"><strong>Blocks Production</strong></span>
                      <ul>

                      
                <li v-for="block in this.$store.state.blocks.filter(block => block.project === project.id)" :key="block.id">

                <div class="control content" v-show="showContentBlock">
                  <table class="table" v-if="this.$store.state.blocks_made != ''">
                    <thead>
                      <th>Quantity</th>
                      <th>Date</th>
                    </thead>
                    <tr v-for="block_made in this.$store.state.blocks_made.filter(block_made => block_made.block === block.id)" :key="block_made.id">
                      <td>{{ block_made.quantity }}</td>
                      <td><span class="pr-4">{{(block_made.date_created).substring(0,10)}}</span> {{ (block_made.date_created).substring(11, 19) }}</td>
                    </tr>
                  </table>
                  <div v-else>
                    <DailyLoading />
                  </div>
                </div>
                <hr class="">
            </li>
            </ul>
              </div>
                    </div>
                  </div>
                </div>
          
              </tr>
            </tbody>
      </div>
</table>
</div>
</div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    name: "projects-table",
    data() {
    return {
      projects: [],
      blocks: [],
      projectsWithBlocks: [],
      projectBlocks:[]
    };
  },
  computed(){
    const projects = this.$store.state.projects
    const blocks = this.$store.state.blocks

    

    this.projectBlocks = projects.map((project) => ({
      ...project,
      blocks: blocks.filter(block => block.project === project.id)
    })
    
    )
  },
  mounted(){
    setInterval(() => {
      this.getProjects()
      this.getBlocks()
      this.getBlockMade()
    }, 2000)
  },
  created() {
    this.getProjects();
    this.getBlocks();
  },
    methods:{
    //...mapActions(["getProjects"]),
    //...mapActions(["getBlocks"]),

    getProjects(){
      axios.get('/api/v1/projects_all/')
            .then(response => {
              console.log(response.data)
              this.$store.commit("setProjects", response.data)
            })
            .catch((err) => console.error(err));
    },
    getBlocks(){
      axios
          .get('/api/v1/blocks/')
          .then(response => {
            console.log(response.data)
            this.$store.commit("setBlocks", response.data)
            
          })
          .catch((err) => console.error(err));
    },
    getBlocksMade(){
      axios
          .get('/api/v1/blocks_made')
          .then(response => {
            //console.log(response.data)
            this.$store.commit("setBlocksMade", response.data)
          })
          .catch((err) => console.error(err));
    },
    toggleContentBlock(){
        this.showContentBlock = !this.showContentBlock;
    },
  },
}
</script>
